import { render, staticRenderFns } from "./ministerConfirmsReply.vue?vue&type=template&id=fa70cd38&scoped=true&"
import script from "./ministerConfirmsReply.vue?vue&type=script&lang=js&"
export * from "./ministerConfirmsReply.vue?vue&type=script&lang=js&"
import style0 from "./ministerConfirmsReply.vue?vue&type=style&index=0&id=fa70cd38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa70cd38",
  null
  
)

export default component.exports